import type { StepConfigFor } from '../getStepConfig.types.ts';

export const DischargeLetterUploadStepConfig = {
  statuses: {
    NOT_STARTED: {
      label: 'Not Uploaded',
      cta: 'Upload Now',
      context: ({ isHealthcareProvider }) =>
        isHealthcareProvider
          ? 'The patient is tasked with uploading their discharge letter'
          : 'Please upload your discharge letter',
    },

    PENDING: {
      label: 'Under Review',
      cta: 'Resubmit',
      context: ({ isHealthcareProvider }) =>
        isHealthcareProvider
          ? 'The patient has uploaded their discharge letter. We need to review it and update the status'
          : 'Your discharge letter is being reviewed. We will update you shortly',
    },

    COMPLETED: {
      label: 'Approved',
      cta: 'View',
      context: ({ isHealthcareProvider }) =>
        isHealthcareProvider
          ? 'The patient has successfully uploaded their discharge letter. We have approved it'
          : 'Your discharge letter has been approved',
    },

    ERROR: {
      label: 'Needs Resubmission',
      cta: 'Resubmit Now',
      context: ({ isHealthcareProvider }) =>
        isHealthcareProvider
          ? 'The uploaded file is incorrect, missing or has missing required information. The patient will need to resubmit it'
          : 'There was an issue with your discharge letter. Please resubmit it',
    },
  },
} satisfies StepConfigFor<'DISCHARGE_LETTER_UPLOAD'>;
